export const formatPhone = (phone) => {
  if (!phone) return "";
  const cleaned = phone.replace(/[^0-9]/g, "");

  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  if (cleaned.length === 11) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
  }
  return phone;
};

export const formatRemainingSlots = (remaining, total) => {
  if (remaining === 0) return "마감";
  return `${remaining}/${total}`;
};

export const formatWinnerRank = (rank) => {
  if (!rank) return "";
  return `${rank}번째 당첨`;
};

export const formatCooldownTime = (cooldownUntil) => {
  if (!cooldownUntil) return "";
  const now = new Date();
  const until = new Date(cooldownUntil);
  const diff = Math.max(0, Math.floor((until - now) / 1000));
  return `${diff}초`;
};

export const getResultMessage = (result) => {
  const messages = {
    WIN: "축하합니다! 당첨되셨습니다!",
    WRONG: "오답입니다. 다시 도전해주세요.",
    CLOSED: "선착순 마감되었습니다.",
    ALREADY_WINNER: "이미 당첨되셨습니다.",
    COOLDOWN: "재응모 대기 중입니다.",
  };
  return messages[result] || "";
};

export const getLotteryUserStatusText = (status) => {
  const statusMap = {
    NOT_SUBSCRIBED: "미청약",
    SUBSCRIBED: "청약 완료",
    WON: "당첨",
    LOST: "미당첨",
  };
  return statusMap[status] || status;
};

export const getDeliveryStatusText = (status) => {
  const statusMap = {
    PENDING: "발송 대기",
    DELIVERED: "발송 완료",
    CANCELLED: "취소됨",
  };
  return statusMap[status] || status;
};
